// extracted by mini-css-extract-plugin
export default {"container":"FindId_container__ef5n2","findBox":"FindId_findBox__hvd7k","title":"FindId_title__eekFj","input":"FindId_input__mUgAb","button":"FindId_button__Q1gm+"};